import { StaysRate } from "@duffel/api/types";

export const getRateLabel = (
  paymentMethod: StaysRate["available_payment_methods"][number],
  paymentType: StaysRate["payment_type"],
): string | undefined => {
  if (paymentMethod === "balance") {
    return "Pay now with Duffel Balance";
  }

  if (paymentMethod === "card" && paymentType === "pay_now") {
    return "Pay now with card";
  }

  if (paymentMethod === "card" && paymentType === "guarantee") {
    return "Card payment at accommodation";
  }

  if (paymentMethod === "card" && paymentType === "deposit") {
    return "Pay deposit with card";
  }

  // fallback
  return "Pay with card";
};
;
import "/Users/igordepaula/.yarn/berry/cache/@sentry-bundler-plugin-core-npm-0.7.2-054e3436fd-10c0.zip/node_modules/@sentry/bundler-plugin-core/sentry-release-injection-file.js";